export default __webpack_public_path__ + "static/media/16.3e5df1c7.pdf";